import { ProductStat } from "../models"
import { LpFilter } from "../models/lp-filter"
import client from "./base"

export const getProductStats = async (pharmacyId: string, filter: LpFilter, adminId?: string) => {

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management${adminId ? '/admins/' + adminId : ''}/pharmacies/${pharmacyId}/product-stats?filter=${JSON.stringify(filter)}`

    return client.get<ProductStat[]>(path).then(res => res.data)
}